// page: string;
// pageBlockFind: string;
// pageBlockCreateDefault: string;
// pageBlockUpdate: string;
// pageBlockPreview: string;
// pageBlockUpdateInactivate: string;
// pageBlockUpdateActive: string;
export const permissionsKeys = {
  page: 'page-config.header-objects',
  pageBlockUpdate: 'page-config.header-objects.page-version.clonePageVersion', //se esta usando la llave update para no modificar la estructura d ela interfaz, pero podria ser pageBlockClonePageVersion
  pageBlockPreview: 'page-config.header-objects.page-block.preview',
  pageBlockUpdateInactivate: 'page-config.header-objects.inactivate.page-block.update',
  pageBlockUpdateActive: 'page-config.header-objects.active.page-block.update',
  pageBlockCreateDefault: 'page-config.header-objects.page-block.create.default', //no se usa
  pageBlockFind: 'page-config.header-objects.page-block.find',
} as const;
